import { GridList, InputAdornment, Paper, TextField, Typography } from "@material-ui/core"
import { createRef, useEffect, useReducer, useState } from "react";
import { useHistory } from "react-router-dom";
import filterIcon from '../../assets/ic_search@3x.png';
import search from '../../assets/search.png';
import api from "../api";
import profile from '../../assets/profile.png';
import PemanggilanAntrian from "./pemanggilanAntrian";
import CloseImage from '../../assets/ic_close.png';
import SearchComponent from '../components/search/SearchComponent'


export default function ListPemanggilanDokter(props) {
    const history = useHistory();
    const wrapperRef = createRef()
    const [dataTable, setDatatable] = useState([])
    const [visibleAntrian, setVisibleAntrian] = useState(false)
    const [doctorID, setDoctorID] = useState(null)
    const [scheduleID, setDoctorScheduleID] = useState(null)
    const [open, setOpen] = useState(true);
    const [name, setName] = useState("");

    useEffect(() => {
        props.setShowNotif(true)
        getListDataDokter()
    }, [])

    const forceUpdate = useReducer(bool => !bool)[1];

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }


    const getListDataDokter = () => {
        api.create().getListDokterPemanggilan().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item, index) => {
                        if (item.session.length > 0) {
                            item.session.map(val => {
                                data.push({
                                    name: item.name,
                                    desc: item.desc,
                                    img: item.media_path,
                                    doctor_id: item.id,
                                    doctor_schedule_id: val.doctor_schedule_id,
                                    time_start: val.time_start,
                                    time_end: val.time_end,
                                    polyclinic_name: item.polyclinic_name
                                })
                            })
                        }
                    })
                    setDatatable(data)
                }
            }
        })
    }

    const handleDetail = (doctorID, scheduleID) => {
        setDoctorID(doctorID)
        setDoctorScheduleID(scheduleID)
        setVisibleAntrian(true)
    }

    const handleFilter = (nama) => {
        api.create().getDokterByKeyword(nama === undefined || nama === null ? name : nama).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item, index) => {
                        if (item.session.length > 0) {
                            item.session.map(val => {
                                data.push({
                                    name: item.name,
                                    desc: item.desc,
                                    img: item.media_path,
                                    doctor_id: item.id,
                                    doctor_schedule_id: val.doctor_schedule_id,
                                    time_start: val.time_start,
                                    time_end: val.time_end,
                                    polyclinic_name: item.polyclinic_name
                                })
                            })
                        }
                    })
                    setDatatable(data)
                }
            }
        })
    }

    return (
        <div>
            {!visibleAntrian && (
                <div style={{ padding: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 10, paddingRight: 10 }}>
                        <SearchComponent
                            placeholder={"Input Nama Dokter"}
                            onSearch={(val)=>{handleFilter(val)}}
                            onDelete={()=>{
                                handleFilter()
                            }}
                            onTypeChange={(val)=>{
                                if(val.length < 1) handleFilter()
                            }}
                        /> 
                    </div>
                    <div style={{ overflow: 'scroll', maxHeight: props.height - 200, marginTop: 20 }}>
                        <GridList cellHeight={240} cols={4} style={{ justifyContent: 'space-between' }} spacing={'5%'}>
                            {dataTable.map((item, index) => (
                                <Paper style={{ display: 'grid', height: 220, borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', margin: 10, width: 400, padding: 10 }}>
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        <img src={item.img === null ? profile : item.img} style={{ width: 60, height: 60, borderRadius: 30 }} />
                                        {/* <div style={{ backgroundColor: 'green', width: 60, height: 60, borderRadius: 30 }} /> */}
                                        <div style={{ marginLeft: 20, width: 'inherit' }}>
                                            <Typography style={{ fontWeight: 'bold' }}>{item.name}</Typography>
                                            <div style={{ marginTop: 10 }}>
                                                 <Typography style={{ color: 'green', fontSize: 11 }}>{item.polyclinic_name}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                        <div style={{}}>
                                            <Typography style={{ color: 'gray' }}>Jam Mulai Praktek</Typography>
                                            <Typography style={{ color: 'black' }}>{item.time_start}</Typography>
                                        </div>
                                        <div style={{ marginLeft: 20 }}>
                                            <Typography style={{ color: 'gray' }}>Jam Selesai Praktek</Typography>
                                            <Typography style={{ color: 'black' }}>{item.time_end}</Typography>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => history.push({
                                            pathname: '/dokter/detail-pemanggilan',
                                            name: 'Detail Pemanggilan',
                                            search: '',  // query string
                                            state: {  // location state
                                                doctorID: item.doctor_id,
                                                doctorName: item.name,
                                                polyclinic: item.polyclinic_name,
                                                scheduleID: item.doctor_schedule_id
                                            },
                                        })}
                                        style={{ width: '80%', height: 35, backgroundColor: '#2a9c6c', boxShadow: '5px 5px 10px 0 #999999', borderRadius: 20, borderColor: 'transparent', outline: 'none', cursor: 'pointer', placeSelf: 'center' }}>
                                        <Typography style={{ color: 'white' }}>Detail</Typography>
                                    </button>
                                </Paper>
                            ))}
                        </GridList>
                    </div>
                </div>
            )}
            {visibleAntrian && (
                <PemanggilanAntrian
                    setSelectNotification={props.setSelectNotification}
                    doctorID={doctorID}
                    scheduleID={scheduleID}
                />
            )}
        </div>
    )
}